import React from 'react';
import ReactDOM from 'react-dom';

// i18n이 초기화 순서 보장
// import 'fasoo-ui-charts/dist/src/i18n';
// import 'fasoo-ui-component-next/dist/src/locales/i18n';
import 'src/i18n';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

// if (import.meta.env.DEV) {
//   (async function () {
//     const { worker } = await import('src/mocks/browser');
//     if (import.meta.env.VITE_APP_MODE === 'debug') {
//       worker.start();
//     } else {
//       worker.start({ onUnhandledRequest: 'bypass' });
//     }
//   })();
// }

const container = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  container
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
